/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import { H6, P } from '~/components/Elements';
import css from './Quote.scss';

const classes = {
	root: css.quote,
	hgroup: css.quoteHgroup,
	title: css.quoteTitle,
	text: css.quoteText,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	children: PropTypes.element,
};

const defaultProps = {
	className: '',
	classes,
};

function Quote(props) {
	return (
		<header className={cls(props.classes.root, props.className)}>
			<div className={cls(props.classes.hgroup)}>
				{H6(props.title, { className: cls(props.classes.title) })}
				{props.children}
			</div>
		</header>
	);
}

Quote.displayName = 'Quote';
Quote.propTypes = propTypes;
Quote.defaultProps = defaultProps;
export default Quote;
